export const EMPTY_REQUIREMENTS = '';
export const FRAGILE_REQUIREMENTS = 'fragile';
export const FOLDABLE_REQUIREMENTS = 'foldable';
export const SHIPS_OWN_CONTAINER_REQUIREMENTS = 'ships_own_container';

export const packagingRequirementsOptions = [
  EMPTY_REQUIREMENTS,
  FRAGILE_REQUIREMENTS,
  FOLDABLE_REQUIREMENTS,
  SHIPS_OWN_CONTAINER_REQUIREMENTS,
];

export const EMPTY_PREFERENCE = 'empty';
export const BOX_PREFERENCE = 'box';
export const BUBBLE_PREFERENCE = 'bubble';
export const POLY_PREFERENCE = 'poly';
export const OWN_BOX_PREFERENCE = 'own_box';

export const allPackagePreferences = [EMPTY_PREFERENCE, BOX_PREFERENCE, BUBBLE_PREFERENCE, POLY_PREFERENCE, OWN_BOX_PREFERENCE];

export const getAvailablePackagePreferences = (packagingRequirement) => {
  switch (packagingRequirement) {
    case FRAGILE_REQUIREMENTS:
      return [EMPTY_PREFERENCE, BOX_PREFERENCE, OWN_BOX_PREFERENCE];
    case SHIPS_OWN_CONTAINER_REQUIREMENTS:
      return [EMPTY_PREFERENCE, OWN_BOX_PREFERENCE];
    case FOLDABLE_REQUIREMENTS:
    case EMPTY_REQUIREMENTS:
    default:
      return allPackagePreferences;
  }
};
